import { markHidden, markVisible } from './visibilityTracking';

let isRunningInTeamsBackground = false;
let teamsBackgroundTransitionCount = 0;

export type TeamsBackgroundStateSnapshot = {
    /**
     * Is the app currently in background
     */
    isBackground: boolean;
    /**
     * How many times the app has been sent to the background since boot.
     */
    backgroundTransitionCount: number;
};

export function getTeamsBackgroundState(): boolean {
    return isRunningInTeamsBackground;
}

/**
 * Get The application background statistics at the moment. That is, if the app is currently in background,
 * and how many times it has transitioned to background since the app started.
 */
export function getTeamsBackgroundStateSnapshot(): TeamsBackgroundStateSnapshot {
    return {
        isBackground: isRunningInTeamsBackground,
        backgroundTransitionCount: teamsBackgroundTransitionCount,
    };
}

/**
 * Determines if Teams has been in the background since the given snapshot.
 * @param snapshot Previous background state snapshot to compare against
 */
export function wasTeamsBackgroundSince(snapshot: TeamsBackgroundStateSnapshot): boolean {
    return (
        snapshot.isBackground || teamsBackgroundTransitionCount > snapshot.backgroundTransitionCount
    );
}

export function setTeamsBackgroundState(isBackground: boolean): void {
    if (isBackground && !isRunningInTeamsBackground) {
        teamsBackgroundTransitionCount++;
    }
    isRunningInTeamsBackground = isBackground;
    // Keep visibility tracking in sync — Teams doesn't fire visibilitychange events
    if (isBackground) {
        markHidden();
    } else {
        markVisible();
    }
}
